<template>
  <div>

    <el-col :span="12">
      <EsayacMeskenListesi :Excel="Excel" :ExcelTelegram="ExcelTelegram" @Yenile="$emit('Yenile',true)" v-if="Mesken" :Bina="Bina"
                           :Mesken="Mesken"></EsayacMeskenListesi>
    </el-col>
    <el-col :span="8">
      <EsayacDonem :Donem="Donem" :Bina="Bina" :Fatura="Fatura"></EsayacDonem>
    </el-col>
    <el-col :span="4">
      <BilgiKutu v-if="BilgiKutuData" :data="BilgiKutuData"></BilgiKutu>
      <Notlar :data="Notlars"></Notlar>
    </el-col>
  </div>
</template>

<script>
import EsayacMeskenListesi from "./Comp/EsayacMeskenListesi";
import mWidget from "../Genel/mWidget";
import EsayacDonem from "./Comp/EsayacDonem";
import Notlar from "../Genel/Notlar";
import BilgiKutu from "../Genel/BilgiKutu";

export default {
  components: {BilgiKutu, Notlar, EsayacDonem, mWidget, EsayacMeskenListesi},
  props: ['Bina', 'Mesken', 'Fatura', 'Donem', 'Excel','ExcelTelegram'],
  data() {
    return {
      BilgiKutuData: null,
      activeName: "",
      Notlars: {
        Modul: 's_Bina',
        Modul_id: this.Bina.id
      },

    }
  },
  methods: {},
  created() {
    this.BilgiKutuData = {
      Baslik: 'BİNA BİLGİ',
      Detay: [
        {Baslik: 'Cari Kodu', Bilgi: this.Bina.EntegreKodu},
        {Baslik: 'Bina Adı', Bilgi: this.Bina.Adi},
        {Baslik: 'Yönetim', Bilgi: this.Bina.Yonetim},
        {Baslik: 'Okuma Gün', Bilgi: this.Bina.oGun},
        {Baslik: 'E-Mail', Bilgi: this.Bina.Email},
        {Baslik: 'Mesken Sayısı', Bilgi: this.Mesken.length},
        {Baslik: 'Bölge', Bilgi: this.Bina.oBolge},
        {Baslik: 'Adres', Bilgi: this.Bina.Adres},
        {
          Baslik: 'Koordinat',
          Bilgi: (this.Bina.Koordinat ? '<a target="_blank" href="https://www.google.com/maps/place/' + this.Bina.Koordinat + '">' + this.Bina.Koordinat + '</a>' : '')
        },
        {Baslik: 'İlgili Ad Soyad', Bilgi: this.Bina.Ilgili},
        {Baslik: 'İlgili Telefon', Bilgi: this.Bina.Iletisim},
        {
          Baslik: 'Fatura/Tahsilat',
          Bilgi: this.Bina.OkumaUcreti + '<sup>TL</sup> / ' + this.Bina.TahsilUcreti + '<sup>TL</sup>'
        },
        {Baslik: 'Mobil Uygulama Kodu', Bilgi: this.Bina.MobilKod},
      ]
    }
  }
}
</script>

<style scoped>
h5 {
  padding: 5px;
  background: #eceef6;
}

</style>



// WEBPACK FOOTER //
// src/components/Pack/Esayac/EsayacBinaEkran.vue